// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../../common/JQueryView';
import DateRangePicker from '../../../../common/DateRangePicker';
import dayjs from 'dayjs';

export default class NewView extends JQueryView {
  specifyScheduleTime: boolean;
  showException: boolean;

  constructor(specifyScheduleTime: boolean, showException: boolean) {
    super('.investees.ir_requests.reports.new');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    this.specifyScheduleTime = specifyScheduleTime;
    this.showException = showException;

    this.render();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field').length) {
      $('.date-field').removeClass('focus');

      if ($('.date-field').val().length === 0) {
        $('.date-field').removeClass('form-control-active');
      }
    }
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        minDate: dayjs().toDate(),
        locale: {
          format: 'Y/MM/DD HH:mm',
        },
        timePickerIncrement: 1,
      },
      {
        picker: {
          format: {
            start: 'Y/MM/DD HH:mm',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  render() {
    this.initDateRangePicker(this.$el);
    if (this.specifyScheduleTime || this.showException) {
      $('.company_investee_ir_request_scheduled_at').show();
      $('input[for="specify"]').prop('checked', true);
      $('input[for="not_specify"]').prop('checked', false);
    } else {
      $('input[for="not_specify"]').prop('checked', true);
      $('.company_investee_ir_request_scheduled_at').hide();
    }
  }

  @on({ event: 'click', selector: '#specify' })
  activateSpecifyDeliveryTime(event: Event) {
    const target = event.currentTarget;
    if ($(target).prop('checked')) {
      $('.company_investee_ir_request_scheduled_at').show();
      $('input[for="not_specify"]').prop('checked', false);
    } else {
      $(target).prop('checked', true);
    }
  }

  @on({ event: 'click', selector: '#not_specify' })
  deactivateSpecifyDeliveryTime(event: Event) {
    const target = event.currentTarget;
    if ($(target).prop('checked')) {
      $('.company_investee_ir_request_scheduled_at').hide();
      $('input[for="specify"]').prop('checked', false);
    } else {
      $(target).prop('checked', true);
    }
  }

  @on({ event: 'change', selector: 'input' })
  changeInput() {
    const backButton = $('.back-buttun-before-replace');
    const newBackButton = $(
      '<button type="button" class="btn btn-outline-link back-btn" data-toggle="modal" data-target="#back_modal">もどる</button>',
    );
    const closeButton = $('.close-buttun-before-replace');
    const newCloseButton = $(
      '<button type="button" class="close close-button c-button--remove" data-toggle="modal" data-target="#cancel_modal"></button>',
    );

    closeButton.replaceWith(newCloseButton);
    backButton.replaceWith(newBackButton);
  }
}
